import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWall2Right"><Path fillRule="evenodd" clipRule="evenodd" d="M21 4V20H19V12.4142L13.75 17.6642L12.3358 16.25L15.5858 13H3V11H15.5858L12.3358 7.75L13.75 6.33579L19 11.5858V4H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Right;
